const toBoolean = (val) => val === true || val == 'true' || val == '1';

if (typeof __webpack_require__ !== 'undefined') {
  // values will be populated by webpack EnvironmentPlugin
  module.exports = {
    QUANTUM_UI: toBoolean(process.env.QUANTUM_UI),
    QUANTUM_QS: toBoolean(process.env.QUANTUM_QS),
    QUANTUM: toBoolean(process.env.QUANTUM_QS) || toBoolean(process.env.QUANTUM_UI),
  };
} else {
  // For server side rendering
  const env = require('./lib/env').default;
  module.exports = {
    QUANTUM_UI: toBoolean(env.QUANTUM_UI),
    QUANTUM_QS: toBoolean(env.QUANTUM_QS),
    QUANTUM: toBoolean(env.QUANTUM_QS) || toBoolean(env.QUANTUM_UI),
  };
}
